module.exports = __webpack_public_path__ + "c41b6b00bdde5b4d675da120ebb1821a.png";